import { IconLoader } from '@ui/src';
import TemplateRow from './template-row';
import NotificationSettingsColumnHeader from './notification-settings-column-header';
import { TemplateColumnTypes } from './types';

import cn from './notification-settings.module.css';

const TemplateColumn = ({
  templates,
  isLoading,
  templateId,
  emptyTitle,
  popupIsOpen,
  setRenamePopupVisible,
}: TemplateColumnTypes) => {
  let content: React.JSX.Element;

  if (isLoading) {
    content = (
      <div className={cn.columnLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = templates?.length ? (
      <div
        className={`${cn.columnContent} ${popupIsOpen ? cn.lessHeight : ''}`}
      >
        {templates?.map((template) => (
          <TemplateRow
            template={template}
            key={template.id}
            isSelectedRow={template.id === templateId}
            setRenamePopupVisible={setRenamePopupVisible}
          />
        ))}
      </div>
    ) : (
      <div className={cn.emptyTitle}>{emptyTitle}</div>
    );
  }

  return (
    <div className={cn.column}>
      <NotificationSettingsColumnHeader title="Template" />
      {content}
    </div>
  );
};

export default TemplateColumn;
